import { parseWealthDetailContent } from './wealthDetailContent';

export const buildStaticWealthDetailContent = (product) => ({
  hero: {
    category: product.category,
    title: product.heroTitle,
    description: product.heroDescription,
    cta: {
      text: product.cta,
      url: '/create-account',
    },
    image: '',
  },
  earn: {
    title: product.earnTitle,
    paragraphs: product.earnParagraphs,
    image: '',
  },
  coreParameters: {
    title: 'Core Parameters',
    items: product.coreParameters.map((item) => ({
      ...item,
      icon: item.icon || '',
    })),
  },
  savings: {
    quote: product.savingsQuote,
    eagleImage: '',
  },
  accountFeatures: {
    title: 'Account Features',
    items: product.accountFeatures,
  },
  growth: {
    title: product.growthTitle,
    text: product.growthText,
    cta: {
      text: product.growthCta,
      url: '/create-account',
    },
  },
});

export const resolveWealthDetailContent = (page, product) => {
  const parsed = parseWealthDetailContent(page);
  const fallback = buildStaticWealthDetailContent(product);

  if (!parsed) {
    return fallback;
  }

  return {
    hero: parsed?.hero
      ? {
          ...fallback.hero,
          ...parsed.hero,
          image: parsed.hero.image || fallback.hero.image,
        }
      : fallback.hero,
    earn: parsed.earn
      ? {
          ...fallback.earn,
          ...parsed.earn,
          image: parsed.earn.image || fallback.earn.image,
        }
      : fallback.earn,
    coreParameters: parsed.coreParameters || fallback.coreParameters,
    savings: parsed.savings
      ? {
          ...fallback.savings,
          ...parsed.savings,
          eagleImage: parsed.savings.eagleImage || fallback.savings.eagleImage,
        }
      : fallback.savings,
    accountFeatures: parsed.accountFeatures || fallback.accountFeatures,
    growth: parsed.growth || fallback.growth,
  };
};
